import React, { useState } from "react";
import "../../../../assets/scss/components/toc/orderPlacement/generic/opBuySellTag.scss";
import { EBuyOrSell } from "../../../types/genericTypes";

export interface IOpBuySellTagProps {
	defaultValue?: EBuyOrSell; // default selected value
	onSelect: (id: EBuyOrSell) => void; // the function to be called onSelect
}

const OpBuySellTag: React.FC<IOpBuySellTagProps> = (props: IOpBuySellTagProps) => {
	/**
	 * state and function for selectedValue
	 * selectedValue type is number | string
	 * setSelectedValue(number | string)
	 */
	const [selectedValue, setSelectedValue] = useState(props.defaultValue);

	/**
	 * called when user selects a tag
	 * @param value id of the selected tag
	 * @returns onSelect prop passed from parent
	 */
	function tagSelected(value: EBuyOrSell) {
		setSelectedValue(value);
		return props.onSelect(value);
	}

	return (
		<ul className="op_buy_sell_tag">
			<li className={"tag buy" + (selectedValue === EBuyOrSell.BUY ? " active" : "")} onClick={() => tagSelected(EBuyOrSell.BUY)}>
				BUY
			</li>
			<li className={"tag sell" + (selectedValue === EBuyOrSell.SELL ? " active" : "")} onClick={() => tagSelected(EBuyOrSell.SELL)}>
				SELL
			</li>
		</ul>
	);
};

export default OpBuySellTag;
